import PreAuthorizations from './PreAuthorizations';

export default PreAuthorizations;
